import React, { useEffect, useRef } from "react";
import { TimePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";

const format = "hh:mm A";

interface TimeRangePickerFormikProps {
  value: string | undefined; // expected format "09:00 AM to 10:00 PM"
  onChange: (val: string) => void;
}

const parseTimeRange = (
  timeRangeStr?: string
): [Dayjs, Dayjs] | undefined => {
  if (!timeRangeStr) return undefined;
  const parts = timeRangeStr.split(" to ");
  if (parts.length !== 2) return undefined;

  const start = dayjs(parts[0], format);
  const end = dayjs(parts[1], format);

  if (!start.isValid() || !end.isValid()) return undefined;
  return [start, end];
};

const TimeRangePickerFormik: React.FC<TimeRangePickerFormikProps> = ({
  value,
  onChange,
}) => {
  const timeRange = parseTimeRange(value);
  const lastValidValueRef = useRef<string | undefined>(value);

  useEffect(() => {
    lastValidValueRef.current = value;
  }, [value]);

  const handleChange = (
    dates: (Dayjs | null)[] | null,
    dateStrings: [string, string]
  ) => {
    if (dates && dates[0] && dates[1]) {
      // Both times selected
      const newVal = `${dateStrings[0]} to ${dateStrings[1]}`;
      lastValidValueRef.current = newVal;
      onChange(newVal);
    } else if (dates === null) {
      // Explicit clear by user
      lastValidValueRef.current = "";
      onChange("");
    }
    // Ignore partial selections to avoid clearing/resetting on start time pick only
  };

  return (
    <TimePicker.RangePicker
      value={timeRange}
      onChange={handleChange}
      format={format}
      allowClear
      placeholder={["Start Time", "End Time"]}
      style={{ width: "100% ", height:"50px" }}
    />
  );
};

export default TimeRangePickerFormik;

